import update from 'immutability-helper';
import {
    ADD_INTEGRATION_REQUEST,
    LOAD_INTEGRATION_REQUESTS_FAILED,
    LOAD_INTEGRATION_REQUESTS_STARTED,
    LOAD_INTEGRATION_REQUESTS_SUCCEEDED,
    UPDATE_INTEGRATION_REQUEST,
} from './actions';

const initialState = {
    requests: [],
    loading: false,
    loaded: false,
    error: null,
};

const partnerIntegration = (state = initialState, action) => {
    switch (action.type) {
        case LOAD_INTEGRATION_REQUESTS_STARTED:
            return update(state, {
                loading: { $set: true },
                error: { $set: null },
            });
        case LOAD_INTEGRATION_REQUESTS_SUCCEEDED:
            return update(state, {
                requests: { $set: action.requests },
                loading: { $set: false },
                loaded: { $set: true },
                error: { $set: null },
            });
        case LOAD_INTEGRATION_REQUESTS_FAILED:
            return update(state, {
                loading: { $set: false },
                loaded: { $set: true },
                error: { $set: action.error },
            });
        case ADD_INTEGRATION_REQUEST:
            return update(state, {
                requests: { $push: [action.request] },
            });
        case UPDATE_INTEGRATION_REQUEST:
            return update(state, {
                requests: {
                    $set: state.requests.map(r => (r.id === action.request.id ? action.request : r)),
                },
            });
        default:
            return state;
    }
};

export default partnerIntegration;
